// open new tab
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  } 
}
//
customElements.define('clearance-product-message', class ClearanceProductMessage extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productJsonUrl = this.getAttribute('data-product-json-url');
    this.onloadVariantId = this.getAttribute('data-onload-variant');
    this.formId = this.getAttribute('data-form-id');
    
    this.updateVisibility(this.onloadVariantId);
    document.addEventListener('variant:change', (event) => {
      if(event.detail.abz_form.getAttribute('id') == this.formId) {
        // The variant is empty when the selected options don't match any variant
        this.updateVisibility(event.detail.variant?.id);
      }
    });
  }

  async updateVisibility(currentVariantId) {
    const response = await fetch(this.productJsonUrl);
    const productJson = await response.json();

    const variant = productJson.product.variants.find((variant) => variant.id == currentVariantId);

    variant?.price.endsWith('.97') ? this.style.display = 'block': this.style.display = 'none';
  }
});

// Add class in body when shopify chat box opne
  function waitForChatBox(callback) {
    const interval = setInterval(() => {
      const chatBox = document.getElementById("ShopifyChat");
      if (chatBox) {
        clearInterval(interval);
        callback(chatBox);
      }
    }, 300);
  }

  function observeChatOpenState(chatBox) {
    const observer = new MutationObserver(() => {
      const isOpen = chatBox.getAttribute("is-open") === "true";
      if (isOpen) {
        document.body.classList.add("abz-chat-open");
      } else {
        document.body.classList.remove("abz-chat-open");
      }
    });

    observer.observe(chatBox, {
      attributes: true,
      attributeFilter: ["is-open"]
    });

    // Initial check
    const isOpenInitially = chatBox.getAttribute("is-open") === "true";
    if (isOpenInitially) {
      document.body.classList.add("abz-chat-open");
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    waitForChatBox(observeChatOpenState);
  });


// Product page: keep the "Quantity: 1" label in sync with the quantity input. The +/- buttons set the value without
// firing an event, so clicks are handled too (they bubble here after the selector has updated the value)
const updateQuantityLabel = (event) => {
  const selector = event.target.closest?.('.product-info__quantity-selector');
  const input = selector?.querySelector('input[name="quantity"]');
  const label = selector?.querySelector('[data-rcc-quantity-value]');

  if (input && label) {
    label.textContent = input.value || '1';
  }
};

['click', 'input', 'change', 'keyup'].forEach((type) => document.addEventListener(type, updateQuantityLabel));

// Alert Me restock form: the app re-checks the selected variant 500ms after any click, which can be before the theme has
// swapped in the new variant (it waits for a section re-render), so the form could stay open on an in-stock variant.
// Its check listens for clicks on document, so click its own container once the variant has actually changed. The
// click must come from an element: Cartbot's click listener calls event.target.matches() and, when that throws (a click
// dispatched on document itself), its error handler sends the shopper to /checkout
//
// The app's check only runs 500ms after that click, so the form lingered for half a second. Apply the same rule the app
// uses straight away (show the form when the variant is in its data-daeligiblevariants list, and set its hidden variant
// input), leaving the form alone after a sign-up like the app does. The app's own check still follows and agrees
document.addEventListener('variant:change', (event) => {
  const container = document.querySelector('.da-restock-alerts-container-v1');
  const thankYou = document.querySelector('.da-restock-alerts-msg-success-v1');

  if (container && thankYou?.style.display !== 'inline-block') {
    const variantId = String(event.detail?.variant?.id ?? '');
    const eligibleIds = (container.getAttribute('data-daeligiblevariants') || '').split(',').filter(Boolean);
    const eligible = variantId !== '' && eligibleIds.includes(variantId);

    container.style.display = eligible ? 'block' : 'none';

    const variantInput = document.querySelector('input[name="da-restock-alerts-variant"]');
    if (variantInput) variantInput.value = eligible ? variantId : '';
  }

  document.querySelector('.da-restock-alerts-form-container, .da-restock-alerts-container-v1')?.click();
});

// Product page gallery: keep the "Zoom image 2 of 7" names (snippets/product-gallery.liquid) in step with the images
// shown, which can change with the variant. The gallery is updated on the same event, before this runs
const updateZoomLabels = () => {
  document.querySelectorAll('product-gallery').forEach((gallery) => {
    const labels = Array.from(gallery.querySelectorAll('.product-gallery__media:not([hidden]) [data-rcc-zoom-label]'));

    labels.forEach((label, index) => {
      label.textContent = label.textContent.replace(/\d+(\D+)\d+(\D*)$/, `${index + 1}$1${labels.length}$2`);
    });
  });
};

document.addEventListener('variant:change', () => requestAnimationFrame(updateZoomLabels));
